import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EditDocumentComponent } from '../edit-document/edit-document.component';

@Component({
  selector: 'tx-txdocs-ribbon-bar',
  templateUrl: './txdocs-ribbon-bar.component.html',
  styleUrls: ['./txdocs-ribbon-bar.component.scss'],
})
export class TxdocsRibbonBarComponent {
  @Input() isActiveDocument: boolean = true;
  @Input() unansweredCount: number = 0;
  expanded = true;
  ribbonCollapseButton!: HTMLElement | null;
  @Output() previousClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() showUnansweredOnlyChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() searchClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor(public parent: EditDocumentComponent) {
    this.parent = parent;
  }

  ngAfterViewInit(): void {
    this.ribbonCollapseButton = document.getElementById('txBtnRibbonHide');
    this.listenToRibbonBarCollapseClick();
  }

  ngOnDestroy(): void {
    this.ribbonCollapseButton?.removeEventListener('click', this.onRibbonBarToggle.bind(this));
  }

  listenToRibbonBarCollapseClick() {
    // Add click method to expand/collapse button for Ribbon bar
    this.ribbonCollapseButton?.addEventListener('click', this.onRibbonBarToggle.bind(this));
  }

  onRibbonBarToggle(event: any) {
    // if collapsed the className is 'down'. If expanded there is no class set.
    this.expanded = event.target.className === '';
  }
}
